<div 
  class="pillbox"
  [ngClass]="{
    'pillbox--padding-dense': padding === 'dense',
    'pillbox--padding-none': padding === 'none',
    'pillbox--vertical': orientation === 'vertical'
  }">
  <ng-content></ng-content>
  
  <ng-container *ngIf="canExit">
    <div class="pillbox__divider"></div>

    <app-pin-button
      type="ghost"
      size="small"
      (click)="handleExitClick()"
      icon="times">
    </app-pin-button>
  </ng-container>
</div>